/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "theme-ui";
import React, { ReactNode } from "react";
import Header from "./header/header";
import Footer from "./footer/footer";

// This differs from the main layout in that there is no progress bar
// and the header text is solid.
export default function SecondaryLayout({ children }: { children: ReactNode }) {
  return (
    <React.Fragment>
      {/*  Absolute header */}
      <Header
        className="sticky"
        menuItems={[]}
        includeNavs={false}
        position="relative"
      />

      <main>{children}</main>
      <Footer />
    </React.Fragment>
  );
}
